import { render, staticRenderFns } from "./BoardsModal.vue?vue&type=template&id=1196f532&"
import script from "./BoardsModal.vue?vue&type=script&lang=js&"
export * from "./BoardsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports